export default function FooterSection() {
  return (
    <footer className="bg-stone-900 py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="font-black text-white text-xl mb-4">
              TRANSFORMAÇÃO REAL <span className="text-amber-400">60D</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Programa intensivo de reestruturação empresarial. 60 dias para organizar, controlar e crescer.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {['ri-instagram-line', 'ri-whatsapp-line', 'ri-linkedin-box-line', 'ri-facebook-circle-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full text-white/50 hover:text-white hover:border-white/50 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/40 text-xs font-bold uppercase tracking-widest mb-5">Contato</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-amber-400 text-base mt-0.5" />
                <span className="text-white/60 text-sm leading-relaxed">Manaus, Amazonas — AM<br />Brasil</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-amber-400 text-base" />
                <span className="text-white/60 text-sm">(92) 98439-8338</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-amber-400 text-base" />
                <span className="text-white/60 text-sm">contato@xlabstudio.com.br</span>
              </div>
            </div>
          </div>

          {/* Program */}
          <div>
            <h4 className="text-white/40 text-xs font-bold uppercase tracking-widest mb-5">O Programa</h4>
            <ul className="space-y-3">
              {[
                { label: 'Módulo 1 — Mapa de Gargalos e Alavancas', bonus: false },
                { label: 'Módulo 2 — Gestão e Estrutura Operacional', bonus: false },
                { label: 'Módulo 3 — Organização Financeira', bonus: false },
                { label: 'Módulo 4 — Estrutura Comercial', bonus: false },
                { label: 'Módulo 5 — Inovação e Eficiência Empresarial', bonus: false },
                { label: 'Módulo 6 — Inteligência Artificial Aplicada ao Negócio', bonus: false },
                { label: 'Módulo 7 — Jurídico para Empresas', bonus: true },
              ].map((item) => (
                <li key={item.label}>
                  <a href="#modulos" className="flex items-center gap-2 text-white/50 hover:text-white/80 text-sm transition-colors">
                    {item.label}
                    {item.bonus && (
                      <span className="inline-flex items-center gap-1 bg-indigo-500/20 text-indigo-300 text-[10px] font-black px-1.5 py-0.5 rounded-full whitespace-nowrap">
                        <i className="ri-gift-line" />
                        BÔNUS
                      </span>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">© 2026 Transformação Real 60D. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <a href="/termos-de-uso" className="text-white/30 hover:text-white/60 text-xs transition-colors">Termos de Uso</a>
            <a href="/politica-de-privacidade" className="text-white/30 hover:text-white/60 text-xs transition-colors">Política de Privacidade</a>
          </div>
        </div>

        {/* Developed by */}
        <div className="border-t border-white/5 mt-6 pt-6 flex flex-col items-center justify-center gap-3">
          <div className="flex items-center gap-3">
            <span className="text-white/25 text-xs">Developed by</span>
            <a
              href="https://www.instagram.com/xlab.studio"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="cursor-pointer opacity-70 hover:opacity-100 transition-opacity"
            >
              <img
                src="https://static.readdy.ai/image/5da477fdae7b1d111ee386eccbf37db2/3c55ebf59ab1511d4ad4afbeeca91ce1.png"
                alt="X Lab Studio"
                className="h-8 w-auto object-contain"
              />
            </a>
          </div>
          <a
            href="https://www.instagram.com/xlab.studio"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-amber-500/40 text-white/50 hover:text-amber-400 text-xs font-semibold px-4 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line text-sm" />
            Quer um site como este? Entre em contato!
          </a>
        </div>
      </div>
    </footer>
  );
}
